<template>
  <div class="titlebar df aic jcb">
    <div style="margin-left: 40px" class="df aic fs0" @click="back2patientList">
      <span v-if="isBackVisible" class="iconfont icon-left" style="margin-right: 30px"></span>
      <span>{{ currPatientName }}</span>
    </div>
    <div class="titlebar-info df aic">
      <div>{{ dateTime | dateFormater(dateFormat, true) }}</div>
      <div v-if="vncControl" style="color: yellow; margin-left: 20px">
        {{ $t("langcfg.txtMachineCtrol") }}
      </div>
    </div>
    <div class="df aic w-full h-full fdrr">
      <span
        v-if="!isEdittingVisible"
        class="iconfont icon-shutdown1 right margin-right margin-left-20px"
        @click="showPowerOff"
        style="font-size: 40px"
      ></span>
      <span class="iconfont icon-technology_connected right" v-if="loginState"></span>
      <span
        v-if="!isEdittingVisible"
        @click="$emit('show-settings', true)"
        class="iconfont icon-settings1 right margin-right"
        style="font-size: 40px"
      ></span>
      <span
        class="iconfont icon--log-in right margin-right"
        @click="logoutClick"
        style="font-size: 40px"
      ></span
      ><span
        class="iconfont icon-harddriveyingpan right margin-right margin-left-20px"
        :style="diskStyle"
        v-if="!!diskStyle"
        style="font-size: 40px"
      ></span>
      <ImportOrExportDataButton :currentPage="currentPage" :isEdittingVisible="isEdittingVisible" />
      <span
        v-if="(wifiState && wifiState.ConnStatus === 4) || ethernetState.length"
        class="iconfont right margin-right margin-left-20px"
        :class="ethernetState.length ? 'icon-youxianwangluo' : 'icon-wifi'"
        style="font-size: 45px"
      ></span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import fileSys from "../../fileoprators/fileSystem";
import { Message } from "../../mixins";
import { reqGet } from "../../services/httpreq";
import { getSystemTime, logStdout } from "../../shared/utils";
import version from "../../assets/version.json";
import ImportOrExportDataButton from "./ImportOrExportDataButton.vue";
import { PAGES } from "../../shared/consts";
import wpaWIfi from "../js/wifi/wpa_wifi/index.js";
import ethernet from "../js/ethernet/index";
let interDiskDetect;
export default {
  name: "TitleBar",
  components: { ImportOrExportDataButton },
  data() {
    return {
      dateTime: getSystemTime(),
      wifiState: undefined,
      ethernetState: [],
      diskUsePercent: 0,
      updateInfo: {
        ip: "",
        port: "",
        path: ""
      },
      PAGES,
      dialogVisible: false,
      showPopover: false
    };
  },
  mixins: [Message],
  props: {
    isBackVisible: {
      type: Boolean,
      default: true
    },
    isLoginVisible: {
      type: Boolean,
      default: true
    },
    currentPage: String,
    isEdittingVisible: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.getNetworkState();
    const key = window.settings.language === "zh_CN" ? "domestic" : "foreign";
    this.updateInfo = window.updateSettings[key];
  },
  watch: {
    "wifiState.ConnStatus": {
      handler(v1, v2) {
        if (v1 === 4 && [0, 1].includes(v2)) {
          this.notify(
            this.$t("langcfg.txtWifiConnUpPrompt"),
            this.$t("langcfg.txtPrompt"),
            "success"
          );
        } else if (v1 === 9 && v2 === 4) {
          this.notify(
            this.$t("langcfg.txtWifiConnDownPrompt"),
            this.$t("langcfg.txtPrompt"),
            "warning"
          );
        }
      },
      immediate: true
    },
    ethernetState: {
      handler(v1, v2) {
        if (v1 && v2 && v1.length && !v2.length) {
          this.notify(
            this.$t("langcfg.txtEthernetUpPrompt"),
            this.$t("langcfg.txtPrompt"),
            "success"
          );
        }
        if (v1 && v2 && v2.length && !v1.length) {
          this.notify(
            this.$t("langcfg.txtEthernetDownPrompt"),
            this.$t("langcfg.txtPrompt"),
            "warning"
          );
        }
      },
      immediate: true
    }
  },
  mounted() {
    setInterval(() => {
      this.dateTime = getSystemTime();
    }, 30000);
    this.$bus.$on("updateTime", () => {
      this.dateTime = getSystemTime();
    });
    if (window.updateSettings.isUpdateTipVisible) {
      this.isUpdateEnable((result) => {
        if (result) {
          this.confirm(
            `<div style="text-align: center;">${this.$t("langcfg.txtNewVerisionExists")}</div>
            <div style="color: yellow; font-size: 20px;margin-top: 10px;">(${this.$t(
              "langcfg.txtVersionUpdateNotes"
            )})</div>`,
            this.$t("langcfg.txtKnown"),
            "",
            "",
            "info",
            true
          )
            .then(() => {
              // this.$emit('show-update-dialog')
            })
            .catch((e) => {
              this.dialogVisible = false;
            });
        }
      });
    }
    this.detectStorage();
  },
  methods: {
    getNetworkState() {
      let check = () => {
        return Promise.all([ethernet.getConnectedLan(), wpaWIfi.stateWifi()]).then(
          ([ethernets, wifi]) => {
            this.ethernetState = ethernets;
            this.wifiState = wifi;
            setTimeout(check, 1500);
          }
        );
      };
      check();
    },
    logoutClick() {
      this.confirm(this.$t("langcfg.txtConfirmToSignout"))
        .then(() => {
          this.$emit("logout");
        })
        .catch(() => {});
    },
    isUpdateEnable(callback) {
      let url = `http://${this.updateInfo.ip}:${this.updateInfo.port}/${this.updateInfo.path}/version?sn=${window.uid}`;
      if (this.isLoginVisible) {
        setTimeout(() => {
          this.isUpdateEnable(callback);
        }, 10 * 1000);
        return;
      }
      reqGet(url, (err, data) => {
        if (!err) {
          let _v = data.split("-")[0].trim();
          let result = version.version < _v;
          if (result) {
            callback(result);
          }
        } else {
          setTimeout(() => {
            if (window.updateSettings.isUpdateTipVisible) {
              this.isUpdateEnable(callback);
            }
          }, 15 * 1000);
        }
      });
    },
    showPowerOff() {
      this.confirm(
        this.$t("langcfg.txtPowerOff"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          document.getElementById("loading").innerHTML = this.$t("langcfg.txtClosingDevice");
          document.getElementById("app").innerHTML = "";
          setTimeout(() => {
            fileSys.powerOff();
          }, 500);
        })
        .catch(() => {});
    },
    detectStorageImmediately() {
      this.diskUsePercent = fileSys.GetDiskUsagePercent();
      if (this.diskUsePercent >= 95) {
        this.message(this.$t("langcfg.txtDiskUnEnough"), "error", 2000);
      }
    },
    detectStorage() {
      clearInterval(interDiskDetect);
      this.detectStorageImmediately();
      interDiskDetect = setInterval(
        () => {
          this.detectStorageImmediately();
        },
        5 * 60 * 1000
      );
    },
    back2patientList() {
      window.pupilCorneaSelect = undefined;
      // this.$emit("back-to-patientmanager");
      // return;
      fileSys.getFreeMem((err, freemem) => {
        logStdout("get free memory", freemem);
        if (err) {
          this.$emit("back-to-patientmanager");
          return;
        }
        fileSys.getElectronMem((err, memElUsed) => {
          logStdout("get electron memory", memElUsed);
          if (err) {
            this.$emit("back-to-patientmanager");
            return;
          }
          const G = 1024000;
          if (freemem < 2 * G || memElUsed > 5 * G) {
            fileSys.changePage();
          } else {
            this.$emit("back-to-patientmanager");
          }
        });
      });
    }
  },
  computed: {
    ...mapGetters(["currPatientName", "loginState", "dateFormat", "vncControl"]),
    diskStyle() {
      return this.diskUsePercent >= 95 ? "color: red" : undefined;
    }
  }
};
</script>

<style lang="less" scoped>
.titlebar {
  height: 100%;
  font-size: 30px;
  position: relative;
  .titlebar-info {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .td {
    width: 25%;
    height: 30px;
    vertical-align: middle;
    font-size: @header-fs;
    line-height: @header-fs;
  }
  .td-new {
    width: 33.3%;
  }
  .td-control {
    color: yellow;
  }

  .padding {
    margin-left: @content-to-left;
    padding: 0px 40px;
  }
  span {
    font-size: inherit;
  }
  .patient-list-mask {
    width: 200px;
    height: @titlebar-height;
    position: fixed;
    top: 0px;
    left: 0px;
  }
  .hover-color:hover {
    color: @btn-hover-color;
  }
  .patient-info {
    padding-left: @content-to-left*3;
  }
  .right {
    float: right;
    margin-right: @content-to-left+20;
  }
  .margin-right {
    margin-right: 50px;
  }
  .margin-left-20px {
    margin-left: 20px;
  }
}
.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 52px;
  min-width: 125px;
  font-size: 20px;
  padding: 10px;
}
.full {
  height: 100%;
}
/deep/ .el-message-box__content {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/TitleBar.vue